import { render, staticRenderFns } from "./QuotationHeader.vue?vue&type=template&id=27b9d7e6&scoped=true&"
import script from "./QuotationHeader.vue?vue&type=script&lang=ts&"
export * from "./QuotationHeader.vue?vue&type=script&lang=ts&"
import style0 from "./QuotationHeader.vue?vue&type=style&index=0&id=27b9d7e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b9d7e6",
  null
  
)

export default component.exports